import { useContext, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { termsOfService, privacyPolicy, refundPolicy } from "../constants/Terms";
import { openChannelChat, CHANNEL_FAIL_MESSAGE } from "../config/channelTalk";
import AlertContext from "../contexts/AlertContext";

export default () => {
  const location = useLocation();
  const linkLocation = location.pathname;
  const alertContext = useContext(AlertContext);

  const [showTermsModal, setShowTermsModal] = useState(false);
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);
  const [showRefundModal, setShowRefundModal] = useState(false);
  return (
    <footer
      style={
        linkLocation.indexOf("video/course") > -1 ? { display: "none" } : {}
      }
    >
      <div id="footer">
        <div className="container">
          <div className="row">
            <div className="d-flex justify-content-between align-items-center py-4">
              <a
                className="btn btn-circle-xlg bg-gray-200"
                target="_blank"
                href="https://www.youtube.com/channel/UCRELSdKly-04TI7mjv_acCw"
              >
                <img
                  src="/images/ddusul/icon/sns-youtube.png"
                  className="w-100"
                />
              </a>
              <div className="d-flex gap-3 ">
                <a className="btn btn-md btn-outline" href="/statementlist">
                  샘플내역서
                </a>
                <a className="btn btn-md btn-outline" href="/payment">
                  이용권
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="border-1"></div>
        <div className="container">
          <div className="row py-4">
            <div
              className="col-sm-9  d-flex justify-content-between"
              id="footer-menu-wrap"
            >
              <div className="footer-menu">
                <div className="SubTitle3 text-dark">서비스</div>
                <ul>
                  <li>
                    <Link to="/costprojects/normal">설계내역</Link>
                  </li>
                  <li>
                    <Link to="/costprojects/copy">입찰내역</Link>
                  </li>
                  <li>
                    <Link to="/costprojects/estimate">견적서</Link>
                  </li>
                  <li>
                    <Link to="/costprojects/worklist">계약서류</Link>
                  </li>
                  <li>
                    <Link to="/excel">엑셀 자동화</Link>
                  </li>
                </ul>
              </div>
              <div className="footer-menu">
                <div className="SubTitle3 text-dark">강의실</div>
                <ul>
                  <li>
                    <Link to="/lectureroom/0">강의실</Link>
                  </li>
                </ul>
              </div>
              <div className="footer-menu">
                <div className="SubTitle3 text-dark">고객센터</div>
                <ul>
                  <li>
                    <Link to="/data">자료실</Link>
                  </li>
                  <li>
                    <Link to="/noticelist">공지사항</Link>
                  </li>
                  <li>
                    <Link to="/inquiry">협업문의</Link>
                  </li>
                  <li>
                    <Link to="/education-application">교육 신청</Link>
                  </li>
                </ul>
              </div>
              <div className="footer-menu">
                <div className="SubTitle3 text-dark">용역 의뢰</div>
                <ul>
                  <li>
                    <Link to="/contact">설계문의</Link>
                  </li>
                  <li>
                    <Link to="/requestapplication">의뢰신청</Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-sm-3 col-12">
              <div className="SubTitle3 text-dark">고객센터</div>
              <h2 className="mt-3">
                <a className="text-dark" href="tel:070-4799-2557">
                  070-4799-2557
                </a>
              </h2>
              <button
                type="button"
                className="btn btn-md btn-primary-soft w-100 btn-full"
                onClick={() =>
                  openChannelChat(() =>
                    alertContext.showAlert(CHANNEL_FAIL_MESSAGE)
                  )
                }
              >
                문의하기
              </button>
              <div className="mt-3 body2">
                오전 10시 ~ 오후 6시 (주말, 공휴일 제외)
              </div>
              <a
                className="btn btn-md btn-dark w-100 btn-full mt-3"
                href="/lectureroom/0"
              >
                콘엑스 사용법
              </a>
            </div>
          </div>
        </div>
        <div className="border-1"></div>
        <div className="container">
          <div>
            <img src="/images/icons/logo-footer.svg" className="footer-logo" />
            <div className="col-12">
              <div className="footer-bottom-menu">
                <ul>
                  <li onClick={() => setShowTermsModal(true)} style={{ cursor: "pointer" }}>
                    이용약관
                  </li>
                  <li onClick={() => setShowPrivacyModal(true)} style={{ cursor: "pointer" }}>
                    <strong>개인정보 처리방침</strong>
                  </li>
                  <li onClick={() => setShowRefundModal(true)} style={{ cursor: "pointer" }}>
                    환불 정책
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-12 copyright mb-4">
              <p>
                주식회사 뚜껑 (대표이사: 양경석) / 제주특별자치도 서귀포 신서로
                102번길 30. 1층 (주)뚜껑사업자등록번호: 686-88-02080 /
                통신판매업신고: 제 2021-제주대천-56호팩스번호 : 0504-434-5924 /
                문의 이메일 : ddk@ddukeong.com
              </p>
              <p>© 2021 DDUKEONG Corp.</p>
            </div>
          </div>
        </div>
      </div>

      {/* 이용약관 모달 */}
      <Modal show={showTermsModal} onHide={() => setShowTermsModal(false)} size="lg" scrollable>
        <Modal.Header>
          <Modal.Title>이용약관</Modal.Title>
          <button type="button" className="btn-close" onClick={() => setShowTermsModal(false)} aria-label="Close"></button>
        </Modal.Header>
        <Modal.Body>
          <pre style={{ whiteSpace: "pre-wrap", fontFamily: "inherit", fontSize: "14px" }}>
            {termsOfService}
          </pre>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-secondary" onClick={() => setShowTermsModal(false)}>
            닫기
          </button>
        </Modal.Footer>
      </Modal>

      {/* 개인정보 처리방침 모달 */}
      <Modal show={showPrivacyModal} onHide={() => setShowPrivacyModal(false)} size="lg" scrollable>
        <Modal.Header>
          <Modal.Title>개인정보 처리방침</Modal.Title>
          <button type="button" className="btn-close" onClick={() => setShowPrivacyModal(false)} aria-label="Close"></button>
        </Modal.Header>
        <Modal.Body>
          <pre style={{ whiteSpace: "pre-wrap", fontFamily: "inherit", fontSize: "14px" }}>
            {privacyPolicy}
          </pre>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-secondary" onClick={() => setShowPrivacyModal(false)}>
            닫기
          </button>
        </Modal.Footer>
      </Modal>

      {/* 환불 정책 모달 */}
      <Modal show={showRefundModal} onHide={() => setShowRefundModal(false)} size="lg" scrollable>
        <Modal.Header>
          <Modal.Title>환불 정책</Modal.Title>
          <button type="button" className="btn-close" onClick={() => setShowRefundModal(false)} aria-label="Close"></button>
        </Modal.Header>
        <Modal.Body>
          <pre style={{ whiteSpace: "pre-wrap", fontFamily: "inherit", fontSize: "14px" }}>
            {refundPolicy}
          </pre>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-secondary" onClick={() => setShowRefundModal(false)}>
            닫기
          </button>
        </Modal.Footer>
      </Modal>
    </footer>
  );
};
